import { useState } from 'react';

import { Grid } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DateRangePicker, MultiInputDateRangeField } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import { ptBR } from 'date-fns/locale';

import { StoreAutoComplete } from 'components/autocompletes';
import { CissAutoComplete } from 'components/autocompletes/CissAutoComplete';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';

const statusOptions = [
    { dreStatus: 1, dsDreStatus: 'A preencher' },
    { dreStatus: 2, dsDreStatus: 'Em preenchimento' },
    { dreStatus: 3, dsDreStatus: 'Finalizado' },
    { dreStatus: 4, dsDreStatus: 'Bloqueado' },
];

export function PreenchimentoListFilter() {
    const [filterLoja, setFilterLoja] = useState<FilterValuesProps>({
        property: 'idLoja',
        operator: 'in',
        value: [],
        idProperty: 'idLoja',
    });

    const [filterInterval, setFilterInterval] = useState<FilterValuesProps>({
        property: 'dtInicio',
        operator: 'bt',
        startDate: new Date(new Date().getFullYear(), 0, 1),
        endDate: new Date(),
        required: 'Intervalo de tempo é obrigatório',
    });

    const [filterStatus, setFilterStatus] = useState<FilterValuesProps>({
        property: 'dreStatus',
        operator: 'in',
        value: [statusOptions[0]],
        idProperty: 'dreStatus',
        required: 'Status é obrigatório',
    });

    return (
        <Filter
            preventQueryParamsEmptyStart
            filters={[
                { value: filterLoja, setter: setFilterLoja },
                { value: filterInterval, setter: setFilterInterval },
                { value: filterStatus, setter: setFilterStatus },
            ]}
        >
            <Grid sx={{ flex: 1 }}>
                <StoreAutoComplete
                    multiple={true}
                    value={filterLoja.value}
                    onChange={(e, value) => setFilterLoja((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                />
            </Grid>

            <Grid sx={{ width: '100%', flex: 1 }}>
                <LocalizationProvider adapterLocale={ptBR} dateAdapter={AdapterDateFns} localeText={{ start: 'Data inicial', end: 'Data final' }}>
                    <DateRangePicker
                        value={[filterInterval.startDate ?? null, filterInterval.endDate ?? null]}
                        onChange={([startDate, endDate]) => {
                            setFilterInterval((oldState: FilterValuesProps) => ({
                                ...oldState,
                                startDate,
                                endDate,
                            }));
                        }}
                        slots={{ field: MultiInputDateRangeField }}
                        slotProps={{ field: { dateSeparator: 'até' } }}
                    />
                </LocalizationProvider>
            </Grid>

            <Grid sx={{ flex: 1 }}>
                <CissAutoComplete
                    label="Status de preenchimento"
                    options={statusOptions}
                    value={filterStatus.value}
                    multiple={true}
                    selectedStringTemplate="{dsDreStatus}"
                    optionStringTemplate="{dsDreStatus}"
                    isOptionEqualToValue={(option, value) => value && option && option.dreStatus === value.dreStatus}
                    onChange={(e, value) => setFilterStatus((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                />
            </Grid>
        </Filter>
    );
}
